export default __webpack_public_path__ + "static/media/pogba.6a8dd06a.png";